<script>
import {Card, createToken} from 'vue-stripe-elements-plus'

export default {
    data() {
        return {
            stripeOptions: {
                hidePostalCode: true,
                style: {
                    base: {
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#8a949f'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                }
            },
            loading: false,
            success: false,
            error: false,
            errorText: null,
            attendees: [
                {
                    open: true,
                    deleted: false,
                    member: false
                }
            ],
            page: 1
        }
    },
    props: [
        "priceMember",
        "priceNonMember",
        "isPaid",
        "modalId"
    ],
    created() {
        Vue.nextTick(() => {
            // Once you close the modal, reset the form
            $('#' + this.modalId).on('hidden.bs.modal', (e) => {
                this.page = 1;
                this.loading = false;
                this.success = false;
                this.error = false;
            });
        });
    },
    components: {Card},
    computed: {
        memberCount() {
            return this.attendees
                .filter(a => a.deleted === false)
                .filter(a => a.member === true)
                .length
        },
        nonMemberCount() {
            return this.attendees
                .filter(a => a.deleted === false)
                .filter(a => a.member === false)
                .length
        },
        memberTotal() {
            return this.priceMember * this.memberCount
        },
        nonMemberTotal() {
            return this.priceNonMember * this.nonMemberCount
        }
    },
    methods: {
        generateFormNameAttribute(name, index) {
            return `attendee[${index}][${name}]`;
        },
        generateFormNameAttributeMulti(name, index) {
            return `attendee[${index}][${name}][]`;
        },
        toggleHidden(index) {
            this.attendees[index].open = !this.attendees[index].open;
        },
        addGuest() {
            this.attendees.push({
                open: true,
                deleted: false,
                member: false
            });
        },
        removeGuest(index) {
            this.attendees[index].deleted = true;
        },
        percievedIndex(index) {
            return this.attendees
                .slice(0, index)
                .filter(value => value.deleted === false).length
        },

        goToPayment() {
            let formIsValid = this.$refs.form.reportValidity();
            if (formIsValid) {
                this.page = 2;
            }
        },

        // Called by onSubmitForm when the event IS paid
        onPaid(e, tries = 1) {
            let form = $(this.$refs.form);
            let fields = form.serializeArray();

            createToken().then(data => {
                if (data.error) {
                    this.error = true;
                    this.loading = false;
                    this.success = false;
                    this.errorText = data.error.message; // This message is already in norwegian
                    return;
                } else {
                    // Reset error state when payment is attempted again
                    this.error = false;
                    this.errorText = null;
                }

                fields.push({name: "token", value: data.token.id});
                let formData = $.param(fields);

                this.onSubmit(formData);
            }).catch(e => {
                // User clicked pay before the stripe element has loaded
                setTimeout(() => {
                    debugger
                    // If this happens 3 times, something else is wrong.
                    if (tries > 2) {
                        this.error = true;
                        this.errorText = "Noe har gått galt, prøv igjenn senere.";
                        return;
                    }
                    this.onPaid(e, tries++);
                }, 500);
            });

        },

        // Called by onSubmitForm when the event is not paid
        onRegister(e) {
            let form = $(this.$refs.form);
            let fields = form.serializeArray();
            let formData = $.param(fields);

            this.onSubmit(formData);
        },

        // Called when the form is submitted
        onSubmitForm(e) {
            e.preventDefault();
            this.loading = true;
            this.isPaid ? this.onPaid(e) : this.onRegister(e);
        },
        onSubmit(formData) {

            $.ajax({
                type: 'POST',
                url: $(this.$refs.form).attr('action'),
                data: formData
            })
                .then(response => {
                    if (response.success) {
                        this.success = true;
                        this.error = false;
                    } else {
                        this.error = true;
                        this.errorText = response.error;
                    }

                    this.loading = false;
                })
        }
    }
}
</script>
